
// function removeMoneySpanAndKeepContent() {
//     const spans = document.querySelectorAll('span.tee-clipart-label__text');
//     spans.forEach(span => {
//         const parent = span.closest('.tee-clipart-label');
//         let regex = /<span class=money>([^<]*)<\/span>/g;

//         if (parent && parent.hasAttribute('data-title')) {
//             let dataTitle = parent.getAttribute('data-title');
//             let updatedDataTitle = dataTitle.replace(regex, '$1');
//             parent.setAttribute('data-title', updatedDataTitle);
//         }
//     });
// }


// document.addEventListener('teeinblue-event-component-injected', function() {
//   setInterval(()=> {
//     removeMoneySpanAndKeepContent();
//   },500)
// })

function removeMoneySpanAndKeepContent() {
    const spans = document.querySelectorAll('span.tee-clipart-label__text');
    const regex = /<span\s+class=["']?money["']?>([^<]*)<\/span>/g;

    spans.forEach(span => {
        const parent = span.closest('.tee-clipart-label');
        let spanHtml = span.innerHTML;
        let updatedHtml = spanHtml.replace(regex, '$1');
        if (spanHtml !== updatedHtml) {
            span.innerHTML = updatedHtml;
        }

        if (parent && parent.hasAttribute('data-title')) {
            let dataTitle = parent.getAttribute('data-title');
            let updatedDataTitle = dataTitle.replace(regex, '$1');
            parent.setAttribute('data-title', updatedDataTitle);
        }
    });

    const options = document.querySelectorAll('select.tee-field__select option');
    options.forEach(option => {
        let value = option.textContent;
        let updated = value.replace(regex, '$1');
        if (value !== updated) {
            option.textContent = updated;
        }
    });
}

document.addEventListener('teeinblue-event-component-injected', function () {
    setInterval(() => {
        removeMoneySpanAndKeepContent();
    }, 500);
});